export default {
  title: "Important message bar",
  important_message: "Important message",
  label: "No important message",
  message: `The purpose of important message bars is to, as the name suggests, convey an urgent or important message
  to the user. It is placed at the top of every page and has a bright red background color to make it as visible as possible.`,
  demo_message: "Here goes your important message"
}
